import React from 'react';
import styles from './banner.module.css';
import {  Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <>
    <div className={styles.wrapper}>
      <header>
        <nav>
          <ul>
            <li>
              <Link to="/">Inicio</Link>
            </li>
          </ul>
        </nav>
      </header>
      <section>
        <header>
          <h1>Quiénes somos</h1>
        </header>

        <p className={styles['about-text']}>Somos una apasionada startup nicaragüense especializada en el desarrollo de software. Nuestro principal objetivo es proporcionar soluciones tecnológicas eficientes y personalizadas para empresas y emprendedores que desean alcanzar su máximo potencial.</p>

        <header>
        <h1 className={ styles['tech-h1'] }>Qué hacemos</h1>
        </header>

        <p className={styles['about-text']}>Nos embarcados en diversos proyectos y servicios tecnológicos emocionantes y, como resultado, estamos buscando ampliar nuestro talentoso equipo con personas tanto con experiencia como sin experiencia previa. Creemos firmemente en el poder del aprendizaje continuo y la pasión por dejar una huella en la sociedad.</p>

        <header>
        <h1 className={styles['our-team']}>Nuestro equipo</h1>
        </header>

        <p id={styles['last']} className={styles['about-text']}>En Gotlim, nos enorgullece contar con un equipo joven y dinámico, repleto de entusiasmo y motivación. Nos apasiona aprender constantemente y abrazar nuevos desafíos en el mundo de la tecnología. Creemos en el poder de la colaboración y la creatividad, y estamos convencidos de que cada uno de nosotros puede marcar la diferencia.</p>
      </section>
    </div>
    </>
  );
}
